import React, { useContext } from 'react'
import MyContext from '../../context/data/myContext';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

function SearchBar8() {
    const context = useContext(MyContext)
    const { filteredData8, wordEntered8, handleFilter8, clearInput8 } = context
  return (
    <div>
        <div className="ml-auto flex items-center">
              <input type="text" placeholder='Buscar...' value={wordEntered8} onChange={handleFilter8} style={{outline: 'none'}} className='bg-gray-100'/>
                <div>
                    {filteredData8.length === 0 ? (<SearchIcon/>) : (<CloseIcon  id="clearBtn" onClick={clearInput8} />) }
                </div>
              </div>
      
    </div>
  )
}

export default SearchBar8